import type { CandleWithFlag } from "features/chart";

export interface DonchianChannelLines {
  upper: (number | null)[];
  middle: (number | null)[];
  lower: (number | null)[];
}

export function calcDonchianChannel(
  data: CandleWithFlag[],
  period: number,
): DonchianChannelLines {
  const n = data.length;
  const upper: (number | null)[] = new Array(n).fill(null);
  const middle: (number | null)[] = new Array(n).fill(null);
  const lower: (number | null)[] = new Array(n).fill(null);

  for (let i = period - 1; i < n; i++) {
    let hi = -Infinity, lo = Infinity;
    for (let j = i - period + 1; j <= i; j++) {
      hi = Math.max(hi, data[j].high);
      lo = Math.min(lo, data[j].low);
    }
    upper[i] = hi;
    lower[i] = lo;
    middle[i] = (hi + lo) / 2;
  }

  return { upper, middle, lower };
}
